// extracted by mini-css-extract-plugin
export default {"title":"AdditionalInfoHeader_title__Hh5gn"};